import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FeaturesConfigModule, I18nModule, UrlModule } from "@spartacus/core";
import {  OutletModule, MediaModule, AtMessageModule, IconModule, ItemCounterModule, ListNavigationModule, PageComponentModule, ProductListModule, SpinnerModule, StarRatingModule, ProductListItemContextSource } from "@spartacus/storefront";
import { RouterModule } from "@angular/router";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { KbAddToCartModule } from "../../kb-add-to-cart/kb-add-to-cart.module";
import { FormsModule } from "@angular/forms";
import { KbDocumentListComponent } from "./kb-document-list.component";
import { KbPipesModule } from "src/app/pipes/kb-pipes.module";

@NgModule({
 imports:[
    AtMessageModule,
    CommonModule,
    FeaturesConfigModule,
    I18nModule,
    IconModule,
    InfiniteScrollModule,
    ItemCounterModule,
    ListNavigationModule,
    MediaModule,
    OutletModule,
    PageComponentModule,
    RouterModule,
    SpinnerModule,
    StarRatingModule,
    UrlModule,
    ProductListModule,
    KbAddToCartModule,
    FormsModule,
    KbPipesModule
 ],
 providers: [
    ProductListItemContextSource
  ],
  exports:[KbDocumentListComponent],
 declarations:[KbDocumentListComponent]
})
export class KbDocumentListItemModule {

}
